import { customRequest, downloadXls, customFetch } from '@/shared/utils'
import { computeParams } from '@/shared/utils/to-params'
import { MOCK_CONFIG } from '@/shared/config/mock-config'

const enum AdminEnum {
    report = '/api/admin/v1/sub_accounts/report/',
    referral = '/api/v1/referral_program/admin/referral_users/',
    users = '/api/v1/referral_program/admin/users/',
    history = '/api/admin/v1/sub_accounts/vsub_earnings/',
    antpoolHistory = '/api/admin/v1/sub_accounts/antpool_earnings/',
    postReferral = '/api/v1/referral_program/admin/update_referral_user/',
}
export function getReport(query: { page: number }) {
    return customRequest
        .getItem<any, any>(AdminEnum.report + computeParams(query))
        .then((res: any) => res.data)
}

export function getHistory(query: any) {
    if (query.xls === '1') {
        // Проверяем конфигурацию для мокинга
        const useMockXls = MOCK_CONFIG.USE_MOCK_XLS

        // Оригинальная реализация
        return customRequest
            .getItem<any, any>(AdminEnum.history, computeParams(query), {
                responseType: 'blob',
            })
            .then((res: any) => downloadXls(res))
    }
    return customRequest
        .getItem<any, any>(AdminEnum.history + computeParams(query))
        .then((res: any) => res.data)
}

export function getReferral(query: { page: number }) {
    return customRequest
        .getItem<any, any>(AdminEnum.referral + computeParams(query))
        .then((res: any) => res.data)
}

export function getUsers() {
    return customRequest
        .getItem<any, any>(AdminEnum.users)
        .then((res: any) => res.data)
}
export function postReferralUser(body: any) {
    return customRequest.post(AdminEnum.postReferral, body)
}

export function getAntpoolHistory(query: any) {
    if (query.xls === '1') {
        // Проверяем конфигурацию для мокинга
        const useMockXls = MOCK_CONFIG.USE_MOCK_XLS

        // Оригинальная реализация
        return customRequest
            .getItem<any, any>(AdminEnum.antpoolHistory, computeParams(query), {
                responseType: 'blob',
            })
            .then((res: any) => downloadXls(res))
    }
    return customRequest
        .getItem<any, any>(AdminEnum.antpoolHistory + computeParams(query))
        .then((res: any) => res.data)
}

export function updateUserDocuments(formData: FormData) {
    // The interceptor will automatically remove Content-Type for FormData
    // Axios will then set it automatically to multipart/form-data with boundary
    return customFetch.post('/api/admin/v1/sub_accounts/user/documents/update/', formData)
}
